var map = {
	"./agpay/icon_password_default.png": "9356",
	"./aipay/icon_password_default.png": "ebc4",
	"./qpay/icon_password_default.png": "2ae1",
	"./qtpay/icon_password_default.png": "6acd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a504";